import { useShallow } from 'zustand/shallow';

import { ArticleDataHandler } from 'app/modules/wallforming/components/scenes/objects/articles/ArticleDataHandler';
import { PlacementPreview } from 'app/modules/wallforming/components/scenes/objects/placement-preview/PlacementPreview';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

interface ArticlesHandlerFactoryProps {
    isMainCanvas: boolean;
}

export const ArticlesHandlerFactory = ({ isMainCanvas }: ArticlesHandlerFactoryProps) => {
    const articleIds = usePlacementStore(useShallow((state) => Object.keys(state.articles)));

    if (articleIds.length === 0 && !isMainCanvas) {
        return null;
    }

    return (
        <>
            {isMainCanvas && <PlacementPreview isMainCanvas={isMainCanvas} />}
            {articleIds.map((articleId) => (
                <ArticleDataHandler key={articleId} articleId={articleId} isMainCanvas={isMainCanvas} />
            ))}
        </>
    );
};
